import './style.scss';
import {  useAccountInfo } from './hooks';
import { CorporateAccountInfo } from './corporate';
import { PersonalAccountInfo } from './personal';
import { AccountType } from 'views/utils/enums';

export const AccountInfo = () => {
  const props = useAccountInfo();

  switch(props.accountInfo.data?.GetAccountInfo?.AccountType){
    case AccountType.Corporate:
      return <CorporateAccountInfo {...props}/>;
    case AccountType.Personal:
      return <PersonalAccountInfo {...props}/>;
    default:
      return <></>;
  }
};
